import React, { FC, Suspense } from 'react';
import styled, { css } from 'styled-components';
import { Typography } from '../Typography';

const Tooltip = React.lazy(() => import('../Tooltip'));

export interface FormFieldInlineProps {
  label: string;
  htmlFor?: string;
  tooltipText?: string;
  tooltipInfoIcon?: boolean;
  required?: boolean;
}

interface StyledLabelProps {
  tooltip: boolean;
}

const StyledFormFieldInline = styled.div`
  ${({ theme: { space } }) => css`
    gap: ${space.sm};
    display: flex;
    flex-direction: row;
    label {
      display: flex;
      align-items: center;
      gap: ${space.sm};
      font-weight: normal;
      sup {
        margin-left: -${space.sm};
      }

      &:hover {
        cursor: pointer;
      }
    }
  `};
`;

export const FormFieldInline: FC<React.PropsWithChildren<FormFieldInlineProps>> = ({
  label,
  htmlFor,
  children,
  tooltipText,
  tooltipInfoIcon,
  required,
  ...rest
}) => (
  <StyledFormFieldInline {...rest}>
    {children}
    <Typography variant="titleSmall" htmlFor={htmlFor} as="label">
      {label}
      {required && <sup>*</sup>}
      <Suspense>{tooltipText && <Tooltip text={tooltipText} infoIcon={tooltipInfoIcon} />}</Suspense>
    </Typography>
  </StyledFormFieldInline>
);
